module.exports = __webpack_public_path__ + "img/18.59f54826.jpg";